/* ═══════════════════════════════════════════════════════════════
   PROVIMAX ANIMATIONS JS
   ═══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── Page transition overlay ──────────────────────────────── */
  var overlay = document.getElementById('pv-page-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'pv-page-overlay';
    document.body.appendChild(overlay);
  }

  // Fade in after navigation
  window.addEventListener('pageshow', function () {
    overlay.classList.remove('pv-out');
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href]');
    if (!link) return;
    // If another handler already called preventDefault() (e.g. cart-drawer.js,
    // modal triggers, drawer toggles), respect that and skip the transition.
    if (e.defaultPrevented) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    if (href.indexOf('mailto:') === 0 || href.indexOf('tel:') === 0) return;
    if (link.target === '_blank') return;
    if (/^https?\/\//.test(href) && href.indexOf(window.location.hostname) === -1) return;
    // Skip links that explicitly opt out
    if (link.getAttribute('data-no-transition') !== null) return;
    // Never intercept the cart icon — let cart-drawer.js handle it
    if (link.id === 'cart-icon-bubble') return;

    e.preventDefault();
    overlay.classList.add('pv-out');
    setTimeout(function () {
      window.location.href = href;
    }, 280);
  });

  /* ── Scroll reveal ────────────────────────────────────────── */
  // Selectors to auto-tag for reveal
  var SELECTORS = [
    '.section-header',
    '.section-header__title',
    '.section-header__description',
    '.rich-text__wrapper > *',
    '.image-with-text__content > *',
    '.multicolumn-list__item',
    '.card-wrapper',
    '.collection-list__item',
    '.blog-articles .article-card',
    '.pv-about-block',
    '.pv-contact-row > *',
    '.pv-cat-strip',
    '.featured-collection .title',
    '.featured-collection .description',
    '.footer__content-top > *',
    '.footer-block',
  ].join(', ');

  var observer;

  function onEntry(entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('pv-in');
        observer.unobserve(entry.target);
      }
    });
  }

  function initReveal() {
    // Create observer
    observer = new IntersectionObserver(onEntry, {
      threshold: 0.07,
      rootMargin: '0px 0px -50px 0px'
    });

    var elements = document.querySelectorAll(SELECTORS);
    elements.forEach(function (el) {
      if (el.classList.contains('pv-reveal')) return; // already tagged
      el.classList.add('pv-reveal');

      // Stagger card grids and multi-column items
      if (
        el.classList.contains('card-wrapper') ||
        el.classList.contains('multicolumn-list__item') ||
        el.classList.contains('collection-list__item') ||
        el.classList.contains('footer-block')
      ) {
        var siblings = Array.from(el.parentElement.children).filter(function (c) {
          return c.classList.contains(el.classList[0]);
        });
        var idx = siblings.indexOf(el);
        if (idx >= 0) {
          el.dataset.d = String(Math.min(idx % 6, 5) + 1);
        }
      }

      // Alternate slide direction for two-column layouts
      if (el.classList.contains('pv-about-block')) {
        var allBlocks = document.querySelectorAll('.pv-about-block');
        var blockIdx = Array.prototype.indexOf.call(allBlocks, el);
        el.dataset.anim = blockIdx % 2 === 0 ? 'right' : 'left';
      }

      observer.observe(el);
    });
  }

  /* ── Counter animation for stats (if any elements with data-count) ── */
  function animateCounters() {
    document.querySelectorAll('[data-pv-count]').forEach(function (el) {
      var target = parseInt(el.dataset.pvCount, 10);
      if (isNaN(target)) return;
      var duration = 1400;
      var start = performance.now();
      function tick(now) {
        var progress = Math.min((now - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = Math.floor(eased * target).toLocaleString();
        if (progress < 1) requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  /* ── Init ─────────────────────────────────────────────────── */
  function init() {
    if ('IntersectionObserver' in window) {
      initReveal();
    } else {
      // Fallback: show everything immediately
      document.querySelectorAll(SELECTORS).forEach(function (el) {
        el.style.opacity = '1';
      });
    }
    animateCounters();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-run when Shopify dynamically loads sections (theme editor)
  document.addEventListener('shopify:section:load', function () {
    initReveal();
  });

})();
